import { supabase } from '../../common/config/supabase';
import { PDFStaticBuilderProps } from '../../common/helpers/pdf-builder';
import { IClientAnnex } from '../../common/interfaces/client-annex.interface';

export const getClientAnnex = async (client_id?: string): Promise<IClientAnnex> => {
  const { data, error } = await supabase
    .from('client_annex')
    .select('*,  clients(companies(name))')
    .eq('client_id', client_id)
    .maybeSingle();

  if (error) {
    throw error;
  }

  return data;
};

export const updateClientAnnex = async (
  clientAnnexId: number | undefined,
  client_id: number,
  config: PDFStaticBuilderProps,
): Promise<IClientAnnex> => {
  const { data, error } = await supabase
    .from('client_annex')
    .upsert({ client_id, config }, { onConflict: 'client_id' })
    .eq('id', clientAnnexId)
    .single();

  if (error) {
    throw error;
  }

  return data;
};
